import { useEffect, useState } from "react";

const useChatScrollBottom = (targetRef, messages) => {
  const [isAtBottom, setIsAtBottom] = useState(true);
  const [userScrolledUp, setUserScrolledUp] = useState(false);

  useEffect(() => {
    const checkIfAtBottom = () => {
      const threshold = 90; // Small buffer to account for minor scroll differences
      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      const isBottom = scrollPosition >= pageHeight - threshold;

      setIsAtBottom(false);

      // If user scrolls up manually, disable auto-scroll
      if (!isBottom && !userScrolledUp) {
        setUserScrolledUp(true);
      }

      // If user scrolls back to the bottom, re-enable auto-scroll
      if (isBottom && userScrolledUp) {
        setUserScrolledUp(false);
      }
    };

    const scrollToBottom = () => {
      if (!userScrolledUp) {
        const scrollOffset = 100;
        window.scrollTo({
          top: document.body.scrollHeight - window.innerHeight - scrollOffset,
          behavior: "smooth", // Smooth scroll
        });
      }
    };

    const isTargetVisible = () => {
      if (!targetRef?.current) return false;
      const rect = targetRef.current.getBoundingClientRect();
      return rect.top <= window.innerHeight && rect.bottom >= 130;
    };

    // Auto-scroll only if:
    // 1. The target is visible OR we're already at the bottom
    // 2. The user hasn't manually scrolled up
    if ((isTargetVisible() || isAtBottom) && !userScrolledUp) {
      scrollToBottom();
    }

    window.addEventListener("scroll", checkIfAtBottom);

    return () => {
      window.removeEventListener("scroll", checkIfAtBottom);
    };
  }, [messages, isAtBottom, targetRef, userScrolledUp]);

  return;
};

export default useChatScrollBottom;
